import { classNames } from "@features/utils/reactFunctions";
import { Alert, AlertProps } from "antd";
import React from "react";

import * as styles from "./NoticeStyle.module.scss";

const Notice = (props: AlertProps) => {
  return (
    <div className={styles.notice}>
      <Alert
        {...props}
        className={classNames( 
          styles[props.type || "default"],
          props.className
        )}
      />
    </div>
  );
};

export default Notice;
